export default [
  {
    name: 'Szabó Ágnes',
    image: require('../images/higenikusok/image002.jpg')
  },
]